export default __webpack_public_path__ + "static/media/blog_02_black.3a64e946.svg";